/**
 * Software Secure Decode Robustness.
 *
 *
 * @beta
 */
export const SW_SECURE_DECODE = 'SW_SECURE_DECODE'
